import * as _ from 'underscore';
import { NewConnection } from './newConnection';
import { ConnectionSection } from './connectionSection';
import { Templates } from '../../compile';
import { ConnectionContentClient, ManagementClient } from 'mappClient/clients';
import { ViewOptions } from 'mappMvc/interfaces/options';
import { ID } from 'mappMvc/const';
import { IValidateConnection, IConnection } from 'mappClient/models';
import { BaseConnectionClient } from '../interface';
import { loading, notify } from 'mappMvc/decorators';
import { Localization } from 'mappMvc/compile';

export class EditConnection extends NewConnection {
	private id: string;

	constructor(client: ConnectionContentClient | ManagementClient, options: ViewOptions) {
		super(
			client,
			_.defaults(options, <ViewOptions>{
				viewId: ID.Dynamic
			})
		);

		this.id = null;
	}

	//overwrite
	public activated(routeSections: string[]): void {
		super.activated(routeSections);
		this.reset();
		this.template(Templates.layouts_base_form_wrapper);
		this.load(routeSections[0]);
	}

	//overwrite
	public serializeValidateConnection(): IValidateConnection {
		let validateConnection: IValidateConnection = super.serializeValidateConnection();
		validateConnection.id = this.id;
		return validateConnection;
	}

	@loading
	@notify(() => Localization.Saved)
	public submit(): Promise<any> {
		return this.validate()
			.then(() => (<BaseConnectionClient>this.client).updateConnection(this.id, this.serialize()))
			.then(() => {
				(<ConnectionSection>this.parent).list();
			});
	}

	@loading
	public load(id: string): Promise<IConnection> {
		return (<BaseConnectionClient>this.client)
			.getConnection(id)
			.then(connection => {
				this.initConnection(connection);
				return connection;
			})
			.catch(() => {
				this.template(Templates.general_notFound);
				return undefined;
			});
	}

	public initConnection(connection: IConnection): void {
		this.provider.clearSelection();
		this.id = connection.id;
		this.provider.selectBy(connection.providerType);
		this.initialCatalog(connection.initialCatalog);
		this.dataSource(connection.dataSource);
		this.port(connection.port);
		this.userId(connection.userId);
		this.password(connection.password);
	}

	//overwrite
	public reset() {
		super.reset();
		this.id = null;
	}
}
